import { useMemo } from 'react';
import { useKeywords } from '@app/hooks';
import { ArticleSimple } from '@app/utils/types';

function useArticlesPage(eventData: any) {
  const articlesDataGroups = eventData?.homePage?.filter(
    (el: any) => el.__typename === 'ComponentNewsNewsGroup'
  );

  const keywords = useKeywords(
    articlesDataGroups?.[0]?.news_groups?.[0]?.keywords || []
  );

  const { articleContent } = useMemo(() => {
    const articlesListingData: Array<{
      item: ArticleSimple;
      groupId: string;
    }> = [];

    articlesDataGroups.forEach((group: any) => {
      (group?.news_groups?.[0]?.news_items || []).forEach(
        (item: ArticleSimple) => {
          articlesListingData.push({
            item,
            groupId: group?.news_groups?.[0]?.slug,
          });
        }
      );
    });

    const finalData = articlesListingData.filter(
      (currentObject, index, self) => {
        return (
          index ===
          self.findIndex((obj) => obj.item.slug === currentObject.item.slug)
        );
      }
    );

    return {
      articleContent: finalData,
    };
  }, [articlesDataGroups]);

  return { articleContent, keywords };
}

export default useArticlesPage;
